/**
 * Channel-Scope-Helfer für den Content-Block-basierten Channels-Editor (C1).
 *
 * Mappt Channel-Packages auf Pills (Master = Produkt-Scope) und liefert die
 * Zeichen-Obergrenze pro Feldtyp aus den Channel-Constraints.
 */

import type { ChannelPillItem } from '@/components/products/v2/shared/ChannelPillsSelector'
import type { ChannelPackage } from '@/types/channel-packages'
import type { BlockType } from '@/types/content-blocks'

/** Baut die Pill-Liste: Master/Produkt zuerst, dann je Channel-Package. */
export function buildChannelPills(packages: ChannelPackage[], masterName: string): ChannelPillItem[] {
  return [
    { id: 'product', name: masterName, isMaster: true },
    ...packages.map((p) => ({
      id: p.id,
      name: p.channel?.name ?? p.channel_id,
    })),
  ]
}

/** Restriktions-Hinweis für kanal-spezifische Feldtypen (undefined = gilt überall). */
export function restrictionNoteFor(blockType: BlockType): string | undefined {
  if (blockType === 'bullets') return 'Amazon · Kaufland · Otto'
  if (blockType === 'seo_meta') return 'Webshops'
  return undefined
}

/** Zeichen-Obergrenze für einen Feldtyp aus den Channel-Constraints (undefined = keine). */
export function maxLengthFor(blockType: BlockType, pkg: ChannelPackage | undefined): number | undefined {
  const c = pkg?.channel?.constraints
  if (!c) return undefined
  if (blockType === 'title') return c.title_max_length
  if (blockType === 'description') return c.description_max_length
  return undefined
}
